import Dashboard from "../pages/DashBoard/Dashboard";
import Videos from "../pages/DashBoard/videos/Videos";
import Assignment from "../pages/DashBoard/Assignment/Assignment";
import AssignmentMark from "../pages/DashBoard/AssignmentMark/AssignmentMark";
import Quizzes from "../pages/DashBoard/Quizzes/Quizzes";
import VideoForm from "../pages/DashBoard/videos/VideoForm";
import AssignmentForm from "../pages/DashBoard/Assignment/AssignmentForm";
import QuizzesForm from "../pages/DashBoard/Quizzes/QuizzesForm";

const privateRouteAdminComponents = [
  {
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    path: "/videos",
    component: <Videos />,
  },
  {
    path: "/addVideo",
    component: <VideoForm isAddForm={true} />,
  },
  {
    path: "/editVideo/:videoId",
    component: <VideoForm isAddForm={false} />,
  },
  {
    path: "/assignments",
    component: <Assignment />,
  },
  {
    path: "/addAssignment",
    component: <AssignmentForm isAddForm={true} />,
  },
  {
    path: "/editAssignment/:assignmentId",
    component: <AssignmentForm isAddForm={false} />,
  },
  {
    path: "/assignmentMark",
    component: <AssignmentMark />,
  },
  {
    path: "/quizzes",
    component: <Quizzes />,
  },
  {
    path: "/addQuizze",
    component: <QuizzesForm isAddForm={true} />,
  },
  {
    path: "/editQuizze/:quizId",
    component: <QuizzesForm isAddForm={false} />,
  },
];

export default privateRouteAdminComponents;
